module.exports = __webpack_public_path__ + "ea121d525886db4bba0699180652c5e4.svg";